import React, { useEffect } from "react";
import Loading from "./Errorandloading/Loading";

function WhatsappRedirect() {
  useEffect(() => {
    // Redirect after a short delay
    const timer = setTimeout(() => {
      window.location.href = "https://api.whatsapp.com/send/?phone=%2B971567333525&text&type=phone_number&app_absent=0";
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return <Loading />;
}

export default WhatsappRedirect;
